(function () {
  'use strict';

  var configElement = document.getElementById('explorador-blog-tracking-config');
  if (!configElement || configElement.dataset.initialized === 'true') return;
  configElement.dataset.initialized = 'true';

  var config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  if (!config.measurement_id || !config.article_id) return;

  var viewed = false;
  var debug = new URLSearchParams(window.location.search).get('blog_tracking_debug') === '1';

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed());
  }

  function send(name, parameters) {
    if (!analyticsAllowed()) return false;
    // Reuse the Google & YouTube integration's tag and identity. No config,
    // page_view or ecommerce events are emitted by this tracker.
    if (typeof window.gtag !== 'function') return false;
    var payload = Object.assign({
      send_to: config.measurement_id,
      blog_article: String(config.article_title).slice(0, 100),
      blog_article_id: String(config.article_id),
      transport_type: 'beacon'
    }, parameters || {});
    if (debug) payload.debug_mode = true;
    window.gtag('event', name, payload);
    return true;
  }

  function recordView() {
    if (!viewed && send('blog_article_view')) viewed = true;
  }

  function positionFor(link) {
    if (link.closest('.expl-cta')) return link.classList.contains('expl-cta__btn') ? 'article_main' : 'article_alternative';
    if (link.closest('.article-coffret__card')) return 'product_card';
    if (link.closest('.article-coffret__ages')) return 'age_selector';
    if (link.closest('.article-coffret__formats')) return 'format_or_pack';
    if (link.closest('.article-coffret--compact')) return 'article_intro';
    if (link.closest('.article-coffret--selection')) return 'article_end';
    if (link.closest('.blog-cta-ages')) return 'legacy_age_selector';
    if (link.closest('.blog-cta')) return 'legacy_article_cta';
    if (link.closest('.seo-article-products__legacy-links')) return 'collection_navigation';
    return '';
  }

  function formatFor(path) {
    if (path.indexOf('/products/pack-enquete-enfant') === 0) return 'pack';
    if (path.indexOf('/products/kit-digital-') === 0 || path.indexOf('/collections/kit-a-imprimer-') === 0) return 'pdf';
    if (path.indexOf('/products/') === 0 || path.indexOf('/collections/coffret-physique-') === 0) return 'coffret';
    return 'collection_mixte';
  }

  function onClick(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    if (event.type === 'click' && event.button > 0) return;
    var element = event.target && event.target.closest ? event.target : event.target && event.target.parentElement;
    var link = element && element.closest('a[href]');
    if (!link) return;
    var position = positionFor(link);
    if (!position || !analyticsAllowed() || typeof window.gtag !== 'function') return;
    var target;
    try { target = new URL(link.href, window.location.href); } catch (_) { return; }
    if (target.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections)\//i.test(target.pathname)) return;

    recordView();
    var plainPath = target.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?\/(?=(?:products|collections)\/)/i, '/');
    var parameters = {
      blog_cta_position: position,
      blog_cta_target: plainPath.slice(0, 100),
      blog_cta_format: formatFor(plainPath)
    };
    // Give the existing tag a short opportunity to dispatch its beacon before a
    // same-tab navigation. Modifier clicks, downloads and new tabs keep native behavior.
    var sameTab = event.type === 'click' && !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self') && !link.hasAttribute('download');
    if (sameTab) {
      var navigated = false;
      var fallback;
      var navigate = function () {
        if (navigated) return;
        navigated = true;
        window.clearTimeout(fallback);
        window.location.assign(target.href);
      };
      parameters.event_callback = navigate;
      parameters.event_timeout = 250;
      event.preventDefault();
      fallback = window.setTimeout(navigate, 250);
    }
    send('blog_cta_click', parameters);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('auxclick', onClick);
  document.addEventListener('visitorConsentCollected', recordView);
  window.addEventListener('xsts-loaded', recordView);

  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
      if (!error) recordView();
    });
  }
  recordView();
  // The theme delays the Google integration. Retry only initialization; never
  // buffer clicks from visitors who have not granted analytics permission.
  var attempts = 0;
  var retry = window.setInterval(function () {
    recordView();
    attempts += 1;
    if (viewed || attempts >= 120) window.clearInterval(retry);
  }, 500);
})();
